export default {
	logs: {
		log: "Журнал:",
		apps: "Приложения",
		tasksAndInstruments: "Задания и инструменты",
		updates: "Обновления",
		server: "Сервер:",
		app: "Приложение:",
		period: "Период:",
		periodNotSelect: "Период не выбран",
		refresh: "Обновить",
		lastSelected: "Последний выбор",
		reverseOrder: "Обратный порядок",
		savePeriod: "Сохранять период",
		withCoef: "С коэффициентом",
		lastSelectNotFound: "Предыдущего выбора не найдено"
	},
	processes: {
		server: "Сервер:",
		stop: "Остановить",
		view: "Вид",
		compact: "Оптимальный",
		full: "Полный",
		saveFile: "Сохранить файл",
		autoRefresh: "Автообновление",
		thisActionStopProcessWantToContinue: "Это действие остановит этот процесс. Продолжать?",
		attention: "Внимание",
		cancel: "Отмена",
		sec: " сек",
		refresh: "Обновление"
	},
	services: {
		server: "Сервер:",
		start: "Запуск",
		restart: "Перезапуск",
		stop: "Остановить",
		willStart: "запустит",
		willRestart: "перезапустит",
		willStop: "остановит",
		thisAction: "Это действие",
		thisServicesContinue: "эти сервисы. Продолжать?",
		thisServiceContinue: "этот сервис. Продолжать?",
		attention: "Внимание",
		cancel: "Отмена",
		operation: "Операция",
		completeSuccess: "выполнена успешно.",
		softSign: "ь",
		whenOperationPerforming: "При выполнении операции",
		errorOccured: "произошла ошибка.",
		diffStatusesOfServicesError: "Невозможно сделать массовую операцию с сервисами разного статуса",
	}
};
